// extracted by mini-css-extract-plugin
export default {"root":"ProtectedTooltip__root--1-oQc"};